import { getPlayers } from './getPlayers'

export const getPlayerCount = {
  persons: { totalItems: getPlayers.publicPersons.items.length, __typename: 'Int' },
}
